enum OrganizationRole {
  MANUFACTURER = 'MANUFACTURER',
  IMPORTER = 'IMPORTER',
  WHOLESALER = 'WHOLESALER',
  DISTRIBUTOR = 'DISTRIBUTOR',
  CUSTOMER = 'CUSTOMER',
  LOCATION = 'LOCATION',
}

export default OrganizationRole;

export const getOrganizationRoleOptions = () => {
  return [OrganizationRole.DISTRIBUTOR, OrganizationRole.CUSTOMER];
};
